import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
    },
    header: {
      marginTop: '2rem',
      display: 'flex',
      alignItems: 'start',
      gap: '1.2rem',

      '& > .MuiIconButton-root svg': {
        width: '0.8em',
        height: '0.8em',
      },

      '& > div': {
        '& > h2': {
          fontSize: '2.4rem',
          fontWeight: 500,
          marginBottom: '0.6rem',
        },
      },
    },

    content: {
      flex: 1,
    },

    footer: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '1rem',
      marginBlock: '1rem',

      '& > button': {
        margin: 0,
        width: 'fit-content',
      },
    },
  }),
)
